module.exports = {"id":"122849","name":"Arouna Koné","rating":"75","photo":"./data/images/photos/1/122849.png","club":{"name":"Sivasspor","logo":"./data/images/clubs/Sivasspor.png"},"positions":["BU","MD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArounaKone0.json
// module id = 471
// module chunks = 0